import { render, staticRenderFns } from "./ViewGatGridFavorites.vue?vue&type=template&id=0a4a86ea&scoped=true&"
import script from "./ViewGatGridFavorites.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a86ea",
  null
  
)

export default component.exports